// extracted by mini-css-extract-plugin
export default {"ul-pagination__stats":"Pagination_ul-pagination__stats__oku14"};